import React, { useState, useEffect} from 'react';
import { Dropdown, DropdownSkeleton, FormLabel, Tooltip} from 'carbon-components-react';
import { useFormContext } from 'react-hook-form';

const FormDropdown = ({label, name, items, itemValueField, itemTextField, disabled, itemToString, onChange, helperText, tooltipContent, props}) => {
    const {register, formState, watch, setValue, trigger} = useFormContext(); 
    const [objValue, setObjValue] = useState(null);
    const watcher = watch(name);

    disabled = disabled ?? false;
    itemValueField = itemValueField ?? "id";
    itemTextField = itemTextField ?? "name";

    let obj = formState.errors[name];
    const array = name.substr(0, name.indexOf("["));
    if(array.length > 0){
        const optionalName = name.replace('.', '?.');
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
    }
    useEffect(() => {
        if(!watcher)
            setObjValue(null);
        if(items)
            setObjValue(items.find(s => s[itemValueField] === watcher));
    }, [watcher]);

    const change = (e) => {
        if(onChange)
            onChange(e);
        if(e)
            setValue(name, e.selectedItem[itemValueField]);
            
        trigger(name);
     
    }

    return ( 
        <div className="mb-6">
        <FormLabel>
            {
            tooltipContent ?
            <Tooltip triggerText={label}>
                {tooltipContent}
            </Tooltip> 
            : <>{label}</>
            }
        </FormLabel>
        {!items ? <DropdownSkeleton />
        :
            <Dropdown
                id={`ddl-${name}`} {...register(name)} 
                hideLabel={true}
                helperText={helperText}
                label={label}
                items={items}
                itemToString={itemToString? itemToString : (item) => (item ? item[itemTextField] : '')}
                selectedItem={objValue ? objValue: null}
                onChange={change}
                disabled={disabled}
                invalidText={obj?.message}
                invalid={!!obj}
            />
        }
        </div>
     );
}
 
export default FormDropdown;